import React from 'react'

import { Row, Col, Card, Badge } from 'react-bootstrap';

export default function ParticipatingSchools(props) {
    const schools = props.schools;
    const schoolElements = schools.map((school, index) =>
        <Col key={index}>
            <a href={school[1]}>
                <Card className="school-card">
                    <Card.Img className="school-logo" alt="School Logo" variant="top" src={school[0]} />
                    <Card.Body>
                        <Card.Title>{school[2]}{school[3] ? <Badge pill variant="secondary">Host</Badge> : ""}</Card.Title>
                    </Card.Body>
                </Card>
            </a>
        </Col>
    );

    return (
        <Row sm={5}>
            {schoolElements}
        </Row>
    )
}
